function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M283.92663406 607.09264719l450.25824469 0 0-321.61234688 64.32151031 0L798.50638906 156.8344025c0-35.49113719-28.83229125-64.32151031-64.32151031-64.32151031L283.92663406 92.51289219c-35.49017812 0-64.32151031 28.83037313-64.32151031 64.32151031l0 128.64589781 64.32151031 0L283.92663406 607.09264719zM862.8298175 349.80181063l-64.32342844-1e-8 0 321.61330594L219.60512375 671.41511656 219.60512375 349.80181063l-64.32342844-1e-8c-35.49017812 0-64.32151031 28.83037313-64.32151031 64.32342844l0 321.61330594c0 35.48921812 28.83229125 64.32246937 64.32151031 64.32246937l0 128.64493875 128.64589781 1e-8L283.92759313 800.06101438l450.25824468-1e-8 0 128.64493875 128.64493875 1e-8L862.83077656 800.06101438c35.49017812 0 64.32246937-28.83325125 64.32246938-64.32246938L927.15324594 414.12523906C927.15228688 378.63314281 898.31999469 349.80181063 862.8298175 349.80181063z",
  "p-id": 3608
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632295026356,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3607,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fb81a1ce.svg";
export { ForwardRef as ReactComponent };